import React, { Component, ReactNode } from 'react';

interface Props {
    children: ReactNode;
    fallback?: ReactNode;
}

interface State {
    hasError: boolean;
    error?: Error;
}

export class ErrorBoundary extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error: Error): State {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: any) {
        console.error('ErrorBoundary caught error:', error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
            if (this.props.fallback) {
                return this.props.fallback;
            }

            return (
                <div className="bg-red-50 border border-red-200 rounded-lg p-6">
                    <h3 className="text-red-800 font-bold mb-2">⚠️ Error Displaying Response</h3>
                    <p className="text-red-700 text-sm mb-3">
                        There was an error rendering the AI response. The raw text is displayed below:
                    </p>
                    <div className="bg-white p-4 rounded border border-red-200 overflow-auto max-h-96">
                        <pre className="text-xs whitespace-pre-wrap text-gray-800">
                            {this.state.error?.message || 'Unknown error'}
                        </pre>
                    </div>
                    <button
                        onClick={() => this.setState({ hasError: false })}
                        className="mt-3 px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
                    >
                        Try Again
                    </button>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
